import { useGlobalState } from '../../state/GlobalStateProvider';
import { Flexbox } from '../action/Flexbox';
import './AfterLoggedIn.scss';
import LoginPage from './LoginPage';

export const UserLoading = () => {
  return (
    <Flexbox flexDirection='column' justifyContent='center' className='login_screen' gap='1.5rem'>
      <span className='login_screen__loader'></span>
    </Flexbox>
  );
};

const AfterLoggedIn = ({ children }) => {
  const [{ user, userLoading }] = useGlobalState();

  if (userLoading || user === undefined) return <UserLoading />;
  if (!user) return <LoginPage />;
  return children;
};

export default AfterLoggedIn;
